import React from 'react';
import HotAccessoriesCard from './HotAccessoriesCard.js';
import '../Styles/HotAccessories.css';
import { Link } from 'react-router-dom';


const HotAccessories = ({music,musicCover,mobileAccessories,mobileAccessoriesCover,lifestyle,lifestyleCover,home,homeCover,smartDevice,smartDeviceCover}) => {
  return (
    <div className='hotaccessories'>
        <div className='musiccover'>
            <Link exact to="/music">
                <img src={musicCover || mobileAccessoriesCover || lifestyleCover || homeCover || smartDeviceCover} alt="music"/>
                
            </Link>
        </div>
        <div className='musicitem'>
            
           {music && music.map((item,index)=><HotAccessoriesCard key={item.image} image={item.image} price={item.price} name={item.name} index={index}/>)}
           {smartDevice && smartDevice.map((item,index)=><HotAccessoriesCard key={item.image} image={item.image} price={item.price} name={item.name} index={index}/>)}
           {lifestyle && lifestyle.map((item,index)=><HotAccessoriesCard key={item.image} image={item.image} price={item.price} name={item.name} index={index}/>)}
           {home && home.map((item,index)=><HotAccessoriesCard key={item.image} image={item.image} price={item.price} name={item.name} index={index}/>)}
           {mobileAccessories && mobileAccessories.map((item,index)=><HotAccessoriesCard key={item.image} image={item.image} price={item.price} name={item.name} index={index}/>)}
           <HotAccessoriesCard image="https://i01.appmifile.com/webfile/globalimg/in/cms/593181BE-7DB8-15F5-E907-506427B8C9F4.jpg"/>
        </div>
        
        

</div>
  )
}

export default HotAccessories